import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { apiClient } from '@/services/api'

type PublicConfig = Record<string, any>

interface ConfigStore {
  configs: PublicConfig | null
  lastLoadedAt?: number
  isLoading: boolean
  error?: string | null
  load: () => Promise<void>
  refreshIntervalMs: number
  startAutoRefresh: () => void
  startSSE: () => void
}

export const useConfigStore = create<ConfigStore>()(
  persist(
    (set, get) => ({
      configs: null,
      isLoading: false,
      error: null,
      refreshIntervalMs: 60_000,
      load: async () => {
        try {
          set({ isLoading: true, error: null })
          const res = await apiClient.get('/config')
          if (res?.success) {
            set({ configs: res.data || {}, lastLoadedAt: Date.now() })
          }
        } catch (e: any) {
          set({ error: e?.message || '加载配置失败' })
        } finally {
          set({ isLoading: false })
        }
      },
      startAutoRefresh: () => {
        const { refreshIntervalMs, load } = get()
        // 避免重复启动
        if ((window as any).__configRefreshTimer) return
        ;(window as any).__configRefreshTimer = setInterval(() => {
          load().catch(() => void 0)
        }, refreshIntervalMs)
      },
      startSSE: () => {
        if ((window as any).__configSSE) return
        try {
          const base = (import.meta.env.DEV ? '' : (import.meta.env.VITE_API_URL?.replace(/\/api$/, '') || ''))
          const url = `${base}/api/config/stream`
          const es = new EventSource(url)
          es.addEventListener('config', async () => {
            // 收到服务端推送后立即拉取最新配置
            await get().load()
          })
          ;(window as any).__configSSE = es
        } catch {
          // 回退到定时刷新
          get().startAutoRefresh()
        }
      }
    }),
    {
      name: 'public-config',
      storage: createJSONStorage(() => localStorage),
      partialize: (s) => ({ configs: s.configs, lastLoadedAt: s.lastLoadedAt })
    }
  )
)


